import { render } from "./App.vue?vue&type=template&id=e52dde82"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__